import { Box } from '@mui/material';
import React from 'react';
import CAppFilterSelect from '../../../../../../../app/components/CAppFilterSelect';
import IFund from '../../../../../interfaces/fund/IFund';
import IInvestExpertiseFilters from '../../../../../interfaces/expertise/IInvestExpertiseFilters';
import { useTranslation } from 'react-i18next';

type CFiltersClassificationAMFSelectProps = {
	optionsClassificationAMFs: { id: string; name: string }[];
	filters: IInvestExpertiseFilters;
	onChange: (filters: IInvestExpertiseFilters) => void;
	label: string;
	multipleRenderLabelLangTag: string;
};

const CFiltersClassificationAMFSelect = (props: CFiltersClassificationAMFSelectProps) => {
	const { optionsClassificationAMFs, filters, onChange, label, multipleRenderLabelLangTag } = props;

	const { t } = useTranslation();

	return (
		<>
			{optionsClassificationAMFs ? (
				<CAppFilterSelect
					className="filter-classification-amf"
					multiple
					multipleRenderTags={(val: IFund[]) => (
						<Box style={{ paddingLeft: '5px', fontSize: '0.85rem' }}>
							{t(multipleRenderLabelLangTag, { count: val ? val.length : 0 })}
						</Box>
					)}
					value={
						filters?.classificationAMFs
							? optionsClassificationAMFs.filter((x) => filters.classificationAMFs?.includes(x.id))
							: null
					}
					onChange={(val: { id: string; name: string }[]) =>
						onChange({
							...filters,
							classificationAMFs: val ? val.map((x) => x.id) : undefined,
						})
					}
					label={label}
					size="small"
					options={optionsClassificationAMFs}
				/>
			) : (
				<></>
			)}
		</>
	);
};

export default CFiltersClassificationAMFSelect;
